/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// document.addEventListener("DOMContentLoaded", function () {
//     const initSlider1 = () => {
//         const sliderElement2 = document.querySelector("#bannerslider");
//         if (sliderElement2) {
//             const splides = new Splide(sliderElement2, {
//                 arrows: false,
//                 type: 'loop',
//                 autoplay: true,
//             }).mount();

//             const pagination = document.querySelector('#bannerslider .splide__pagination');
//             if (pagination) {
//                 const btnNext = document.createElement('li');
//                 btnNext.id = 'btnNext';
//                 pagination.insertBefore(btnNext, pagination.firstChild);

//                 const btnPrev = document.createElement('li');
//                 btnPrev.id = 'btnPrev';
//                 pagination.appendChild(btnPrev);

//                 // Add event listeners
//                 btnNext.addEventListener('click', function () {
//                     splides.go('-1');
//                 });

//                 btnPrev.addEventListener('click', function () {
//                     splides.go('+1');
//                 });
//             }
//         } else {
//             console.error("Slider element not found!");
//         }
//     };

//     // Check if we are in the Gutenberg editor
//     if (document.body.classList.contains('block-editor-page')) {
//         // Delay initialization in Gutenberg editor
//         setTimeout(initSlider1, 3000);
//     } else {
//         // Immediate initialization on the frontend
//         initSlider1();
//     }
// });


document.addEventListener('DOMContentLoaded', function () {
    const sliderElement2 = document.querySelector("#bannerslider");
    if (sliderElement2) {

        const splides = new Splide(sliderElement2, {
            arrows: false,
            type: 'loop',
            autoplay: true,
        });

        // Add custom pagination controls
        splides.on('pagination:mounted', function (pagination) {
            const paginationList = pagination.list;

            // Create "Prev" and "Next" items
            const prevItem = document.createElement('li');
            prevItem.className = 'custom-arrow prev';
            prevItem.innerHTML = 'Prev';
            paginationList.insertBefore(prevItem, paginationList.firstChild);

            const nextItem = document.createElement('li');
            nextItem.className = 'custom-arrow next';
            nextItem.innerHTML = 'Next';
            paginationList.appendChild(nextItem);

            // Add click events for custom arrows
            prevItem.addEventListener('click', () => splides.go('<'));
            nextItem.addEventListener('click', () => splides.go('>'));
        });

        // Mount the Splide instance
        splides.mount();

    }
});

/* eslint-enable no-console */
